import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {SearchImageRequestParams} from "../../../core/icons/search.image-request-params";
import {COLORS} from "../../../core/app/consts/colors";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {SVGImage} from "../../../core/components/image/svg-image";

export const NewSearchWidgetSearchEmptyState = observer(({controller}) => {
  const {state, terms} = controller;
  const {query} = state;
  const {WEB_SEARCH_NO_RESULT_EMPTY_STATE_HEADER, WEB_SEARCH_NO_RESULT_EMPTY_STATE_BODY} = terms;

  const searchIconProps = {
    src: new SearchImageRequestParams(56, 56),
    className: classNames(styles.search_empty_state_icon),
    fillcolor: useThemeColor(COLORS.textSecondary)
  };

  return <div className={classNames(styles.search_empty_state)}>
    <SVGImage {...searchIconProps}/>
    <div className={classNames(styles.search_empty_state_title)}>{`${WEB_SEARCH_NO_RESULT_EMPTY_STATE_HEADER} "${query}"`}</div>
    <div className={classNames(styles.search_empty_state_description)}>{WEB_SEARCH_NO_RESULT_EMPTY_STATE_BODY}</div>
  </div>
});
